import React from 'react';
import HolidayPlanningCalendar from '../../../components/Holiday/Planning/HolidayPlanningCalendar';

export default function Planning() {
  return (
    <div className="page-content px-0">
      <HolidayPlanningCalendar />
    </div>
  );
}
